import React, { useEffect } from "react";
import * as notify from "shared/notify";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { DEFAULT_VALUES, OFFSET, SCREEN_BORDERS } from "./helpers";

export const DraggablePanelHeader = ({ togglePanel, roleLabel, roleType, isQaEdit, isDirty, isValidationProcessing, savePanel, popoutRef }) => {
    useEffect(() => {
        document.addEventListener("mouseup", onStopMove);
        document.addEventListener("mousemove", onMove);

        return () => {
            document.removeEventListener("mouseup", onStopMove);
            document.removeEventListener("mousemove", onMove);
        };
    }, []);

    var target = null;

    const onStartMove = (e) => {
        target = isQaEdit ? popoutRef.current.parentElement : popoutRef.current;

        e.stopPropagation();
        e.preventDefault();
    };

    const onStopMove = (e) => {
        target = null;

        e.stopPropagation();
        e.preventDefault();
    };

    const onMove = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!target) {
            return;
        }

        let translateX = `${e.clientX - OFFSET.x}px`;
        let translateY = `${e.clientY - OFFSET.y}px`;
        let wRect = DEFAULT_VALUES[`coder_${roleType}`];
        var tgtRect = target.getBoundingClientRect();
        var scrollBarWidth = window.innerWidth - document.body.clientWidth;

        if (e.clientY <= 0) {
            translateY = `${SCREEN_BORDERS.TOP}px`;
        }

        if (e.clientX <= 285) {
            translateX = `${SCREEN_BORDERS.LEFT}px`;
        }

        if (e.clientX > wRect.right + tgtRect.width) {
            translateX = wRect.right + tgtRect.width - scrollBarWidth + "px";
        }

        popoutRef.current.style.transform = `translateX(${translateX}) translateY(${translateY})`;
    };

    const handleClosePanel = async (e) => {
        e.preventDefault();

        if (isDirty && isQaEdit) {
            const confirm = await notify.confirm("You have unsaved data.  Are you sure you want to navigate away? Unsaved data will be lost!");

            if (!confirm) {
                return;
            }
        }

        togglePanel(false);
    };

    return (
        <div
            onMouseDown={onStartMove}
            className={classnames("popout-controls", { "-default-cursor": isQaEdit })}
        >
            <button
                className="button-close"
                disabled={isValidationProcessing}
                onClick={(e) => {
                    handleClosePanel(e);
                }}
            >
                <FontAwesomeIcon icon={faTimes} />
            </button>
            <h3 className="panel-header">Nutrition Panel - {roleLabel}</h3>
            {isQaEdit && (
                <button
                    disabled={isValidationProcessing}
                    className="button -default"
                    onClick={savePanel}
                >
                    Save
                </button>
            )}
        </div>
    );
};
